<template>
  <div>
    <!-- <div v-if="!step">loading...</div> -->
    <bank-step1 
      @nextPage="nextPage"
      v-if="step === 1"
    />
    <bank-step2 
      @nextPage="nextPage"
      v-if="step === 2"
      :action= "action"
      :pOrderId= "pOrderId"
      :authType= "authType"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,
      action: "",
      pOrderId: "",
      authType: ""
    }
  },
  mounted(){
  },
  methods: {
    nextPage(data){
      this.step++
      if(data){
        this.action = data.action
        this.pOrderId = data.pOrderId
        this.authType = data.authType
      }
      
    }
  }
};
</script>
<style>
 
</style>
